import {HttpParams} from '@angular/common/http';
import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {BaseComponent, SearchQuery, Term} from 'compob2b-libs';
import {Observable, of} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map, switchMap, take, takeUntil, tap} from 'rxjs/operators';

@Component({
  selector: 'app-terms-by-id',
  templateUrl: './terms-by-id.component.html'
})
export class TermsByIdComponent extends BaseComponent implements OnInit {
  @Input() modelId: any;
  @Input() urlGet: any;
  @Input() urlSearch: any;
  @Input() urlSave: any;
  @Input() urlDelete: any;
  inputFormControl: FormControl;
  terms$: Observable<Term[]>;
  queries: SearchQuery[] = [];

  ngOnInit(): void {
    this.getQuery();
    this.inputFormControl = new FormControl();
    this.terms$ = this.inputFormControl.valueChanges
      .pipe(
        debounceTime(100),
        distinctUntilChanged(),
        filter(term => term !== null),
        map((term: string) => term.length <= 2 ? null : term),
        switchMap((term: string) => this.searchTerms(term)),
      );
  }

  getQuery() {
    this.compoApiService.get<SearchQuery[]>(this.urlGet + this.modelId).pipe(takeUntil(this.unsubscribe)).subscribe(
      response => {
        this.queries = response.data;
        console.log(this.queries);
        this.cdr.detectChanges();
      }
    );
  }

  searchTerms(term: string): Observable<Term[]> {
    const url = this.urlSearch;
    if (null === term || term === undefined || typeof term !== 'string') {
      return of([]);
    }
    term = term.toLowerCase();
    const params = new HttpParams().set('header', term);

    return this.compoApiService.getWithParams<Term[]>(url, params).pipe(
      map(response => {
        const data = response.data;
        if (data.findIndex(item => item.header === term) === -1) {
          data.unshift({id: 0, header: term});
        }
        return data;
      })
    );

  }

  insertTerm(term: Term) {
    if (term) {
      this.compoApiService.post('/search-ranging-group/save-query/' + this.modelId, term)
        .pipe(
          tap(() => {
            this.getQuery();
            this.cdr.detectChanges();
          }),
          take(1)
        ).subscribe();
    }
  }

  removeTerm(term: Term) {
    this.compoApiService.get<any>('/search-ranging-group/remove-query/' + this.modelId + '/' + term.id)
      .pipe(take(1)).subscribe(
      _ => {
        this.getQuery();
        this.cdr.detectChanges();
      }
    );
  }

  viewHandle(value) {
    return typeof value === 'string' ? value.toLowerCase() : '';
  }
}
